var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"couch-image-wrap",on:{"click":_vm.openVideo}},[(this.$store.state.activeComposer != '')?_c('div',[_c('img',{staticClass:"couch-image",attrs:{"src":`/images/composers/${_vm.composer}-Couch.png`,"alt":_vm.composer}}),_c('p',{staticClass:"couch-composer-name"},[_vm._v(_vm._s(_vm.composer))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }